// extracted by mini-css-extract-plugin
module.exports = {"radio-button":"TariffCalculatorDCM_radio-button_Lpwq3"};